import { Component, OnDestroy, OnInit, Type } from "@angular/core";
import { filter, first, switchMap } from "rxjs/operators";
import { CirculationFacade } from "src/app/services/circulation.facade";
import { SubSink } from "subsink";
import { CirculationId } from "../../interfaces/circulation";
import { LogClass, Logger, LogMethod } from "../../logger";
import { NavigationService } from "../../services/navigation.service";
import { StepFacade } from "../services/step.facade";

@Component({
    selector: "circ-step-details",
    templateUrl: "./step-details.component.html",
    styleUrls: ["./step-details.component.scss"],
    standalone: false
})
@LogClass({ source: "StepDetailsComponent" })
export class StepDetailsComponent implements OnInit, OnDestroy {
  public loading = true;
  public providerComponent: Type<unknown>;

  private circulationId: CirculationId;
  private logger: Logger;
  private subscriptions = new SubSink();

  constructor(
    private navigate: NavigationService,
    private stepFacade: StepFacade,
    private circulationFacade: CirculationFacade
  ) {}

  public abort(): void {
    this.navigate.toCirculation(this.circulationId);
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  @LogMethod()
  public ngOnInit(): void {
    const circulation$ = this.circulationFacade
      .getCurrentCirculation()
      .pipe(filter((c) => !!c));

    circulation$
      .pipe(
        switchMap(() => this.stepFacade.getCurrentStepType()),
        filter((c) => !!c),
        first()
      )
      .subscribe((stepType) => {
        this.logger.debug("showing edit-form for:" + stepType.name);
        this.providerComponent = stepType.editComponent;
        this.loading = false;
      });
  }
}
